// extracted by mini-css-extract-plugin
export default {"row":"style_row__nwt3k","board":"style_board__yqkfE"};